import { Fragment, memo, useMemo } from 'react';

import LinearProgress from '@mui/material/LinearProgress';

import { TelegramBotDropModel } from 'v2/types/TelegramBotSettingsModel';
import { formatNumber, percentage } from 'v2/utils';

interface TelegramDropRewardsColumnProps {
  drop: TelegramBotDropModel;
}

export const TelegramDropRewardsColumn = memo<TelegramDropRewardsColumnProps>(({ drop }) => {
  const receivedRewards = useMemo(() => {
    return Object.values(drop.rewardsObjectData).filter(Boolean).length;
  }, [drop]);

  return (
    <Fragment>
      <p>
        {formatNumber(receivedRewards)} out of {formatNumber(drop.rewardIds.length)}
      </p>

      <LinearProgress variant="determinate" value={percentage(receivedRewards, drop.rewardIds.length)} />
    </Fragment>
  );
});

TelegramDropRewardsColumn.displayName = 'TelegramDropRewardsColumn';
